import { AsciiText } from '../framework/AsciiText';
export class HitachiProjector {
    constructor(socket, log) {
        this.socket = socket;
        this.displayBlank = false;
        this.displayFreeze = false;
        this.input = 3; // HDMI 1
        this.power = false;
        this.runTime = 1000;
        this.asyncHandlers = [
            {
                name: 'displayBlankGet',
                regExp: /\xbe\xef\x03\x06\x00\xc8\xd8\x02\x00\x20\x30\x00\x00/,
                callback: (match) => {
                    this.socket.send(AsciiText.decode([0x1d, this.displayBlank ? 0x01 : 0x00, 0x00]));
                },
            },
            {
                name: 'displayBlankSet',
                regExp: /\xbe\xef\x03\x06\x00[\s\S]{2}\x01\x00\x20\x30([\s\S])\x00/,
                callback: (match) => {
                    this.displayBlank = match[1].charCodeAt(0) === 1;
                    this.socket.send(AsciiText.decode([0x06]));
                },
            },
            {
                name: 'displayFreezeGet',
                regExp: /\xbe\xef\x03\x06\x00\xb0\xd2\x02\x00\x02\x30\x00\x00/,
                callback: (match) => {
                    this.socket.send(AsciiText.decode([0x1d, this.displayFreeze ? 0x01 : 0x00, 0x00]));
                },
            },
            {
                name: 'displayFreezeSet',
                regExp: /\xbe\xef\x03\x06\x00[\s\S]{2}\x01\x00\x02\x30([\s\S])\x00/,
                callback: (match) => {
                    this.displayFreeze = match[1].charCodeAt(0) === 1;
                    this.socket.send(AsciiText.decode([0x06]));
                },
            },
            {
                name: 'inputGet',
                regExp: /\xbe\xef\x03\x06\x00\xcd\xd2\x02\x00\x00\x20\x00\x00/,
                callback: (match) => {
                    this.socket.send(AsciiText.decode([0x1d, this.input, 0x00]));
                },
            },
            {
                name: 'inputSet',
                regExp: /\xbe\xef\x03\x06\x00[\s\S]{2}\x01\x00\x00\x20([\s\S])\x00/,
                callback: (match) => {
                    this.input = match[1].charCodeAt(0);
                    this.socket.send(AsciiText.decode([0x06]));
                },
            },
            {
                name: 'powerGet',
                regExp: /\xbe\xef\x03\x06\x00\x19\xd3\x02\x00\x00\x60\x00\x00/,
                callback: (match) => {
                    this.socket.send(AsciiText.decode([0x1d, this.power ? 0x01 : 0x00, 0x00]));
                },
            },
            {
                name: 'runTimeHi',
                regExp: /\xbe\xef\x03\x06\x00\x2a\xfd\x02\x00\x9e\x10\x00\x00/,
                callback: (match) => {
                    this.socket.send(AsciiText.decode([0x1d, (this.runTime & 0xff00) >> 8, 0x00]));
                },
            },
            {
                name: 'runTimeLow',
                regExp: /\xbe\xef\x03\x06\x00\xc2\xff\x02\x00\x90\x10\x00\x00/,
                callback: (match) => {
                    this.socket.send(AsciiText.decode([0x1d, this.runTime & 0x00ff, 0x00]));
                },
            },
            {
                name: 'powerSet',
                regExp: /\xbe\xef\x03\x06\x00[\s\S]{2}\x01\x00\x00\x60([\s\S])\x00/,
                callback: (match) => {
                    this.power = match[1].charCodeAt(0) === 1;
                    this.socket.send(AsciiText.decode([0x06]));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send(AsciiText.decode([0x1c, 0x00]));
                },
            },
        ];
        this.commandExtractor = {
            terminators: [],
            unterminatedRegExp: /\xbe\xef\x03\x06\x00[\s\S]{8}/,
        };
        this.sendTerminator = '';
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code.charCodeAt(0);
            if (this.input === code - 0x30)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.input = (lowestCode !== null && lowestCode !== void 0 ? lowestCode : 0x33) - 0x30;
    }
}
HitachiProjector.emulatorType = 'socketEmulator';
HitachiProjector.key = '-LiTDmBRVZlC0Mm2IevZ';
